const Main = () => import(/* webpackChunkName: "exoty" */ '@/modules/main/main.vue');
const EmptyRouterView = () => import(/* webpackChunkName: "exoty" */ '@/components/EmptyRouter.vue');

const SysAvatarGender = () => import(/* webpackChunkName: "avatar" */ '@/modules/avatar/gender/view/gender.vue');
const SysAvatarImport = () => import(/* webpackChunkName: "avatar" */ '@/modules/avatar/import/view/import.vue');

const SysAvatarBundleAdd = () => import(/* webpackChunkName: "avatar" */ '@/modules/avatar/bundle/view/add.vue');
const SysAvatarBundleEdit = () => import(/* webpackChunkName: "avatar" */ '@/modules/avatar/bundle/view/edit.vue');
const SysAvatarBundleList = () => import(/* webpackChunkName: "avatar" */ '@/modules/avatar/bundle/view/index.vue');
const SysAvatarBundleItem = () => import(/* webpackChunkName: "avatar" */ '@/modules/avatar/bundle/view/item.vue');

const SysAvatarCategoryAdd = () => import(/* webpackChunkName: "avatar" */ '@/modules/avatar/category/view/add.vue');
const SysAvatarCategoryEdit = () => import(/* webpackChunkName: "avatar" */ '@/modules/avatar/category/view/edit.vue');
const SysAvatarCategoryList = () => import(/* webpackChunkName: "avatar" */ '@/modules/avatar/category/view/index.vue');

const SysAvatarColorAdd = () => import(/* webpackChunkName: "avatar" */ '@/modules/avatar/color/view/add.vue');
const SysAvatarColorEdit = () => import(/* webpackChunkName: "avatar" */ '@/modules/avatar/color/view/edit.vue');
const SysAvatarColorList = () => import(/* webpackChunkName: "avatar" */ '@/modules/avatar/color/view/index.vue');

const SysAvatarDefaultAdd = () => import(/* webpackChunkName: "avatar" */ '@/modules/avatar/default/view/add.vue');
const SysAvatarDefaultEdit = () => import(/* webpackChunkName: "avatar" */ '@/modules/avatar/default/view/edit.vue');
const SysAvatarDefaultList = () => import(/* webpackChunkName: "avatar" */ '@/modules/avatar/default/view/index.vue');
const SysAvatarDefaultTranslate = () =>
    import(/* webpackChunkName: "avatar" */ '@/modules/avatar/default/view/translate.vue');

const SysAvatarLayerAdd = () => import(/* webpackChunkName: "avatar" */ '@/modules/avatar/layer/view/add.vue');
const SysAvatarLayerEdit = () => import(/* webpackChunkName: "avatar" */ '@/modules/avatar/layer/view/edit.vue');
const SysAvatarLayerList = () => import(/* webpackChunkName: "avatar" */ '@/modules/avatar/layer/view/index.vue');

const SysAvatarItemAdd = () => import(/* webpackChunkName: "avatar" */ '@/modules/avatar/item/view/add.vue');
const SysAvatarItemEdit = () => import(/* webpackChunkName: "avatar" */ '@/modules/avatar/item/view/edit.vue');
const SysAvatarItemList = () => import(/* webpackChunkName: "avatar" */ '@/modules/avatar/item/view/index.vue');
const SysAvatarItemImageAdd = () => import(/* webpackChunkName: "avatar" */ '@/modules/avatar/item/image/view/add.vue');
const SysAvatarItemImageEdit = () =>
    import(/* webpackChunkName:"avatar" */ '@/modules/avatar/item/image/view/edit.vue');
const SysAvatarItemImageList = () =>
    import(/* webpackChunkName:"avatar" */ '@/modules/avatar/item/image/view/index.vue');

const SysAvatarBackgroundAdd = () =>
    import(/* webpackChunkName: "avatar" */ '@/modules/avatar/background/view/add.vue');
const SysAvatarBackgroundEdit = () =>
    import(/* webpackChunkName: "avatar" */ '@/modules/avatar/background/view/edit.vue');
const SysAvatarBackgroundList = () =>
    import(/* webpackChunkName:"avatar" */ '@/modules/avatar/background/view/index.vue');

export const ROUTE_NAME_AVATAR = {
    GENDER: 'SysAvatarGender',
    IMPORT: 'SysAvatarImport',
    CATEGORY: {
        INDEX: 'SysAvatarCategoryList',
        ADD: 'SysAvatarCategoryAdd',
        EDIT: 'SysAvatarCategoryEdit'
    },
    BUNDLE: {
        INDEX: 'SysAvatarBundleList',
        ADD: 'SysAvatarBundleAdd',
        EDIT: 'SysAvatarBundleEdit',
        ITEM: 'SysAvatarBundleItem'
    },
    DEFAULT: {
        INDEX: 'SysAvatarDefaultList',
        ADD: 'SysAvatarDefaultAdd',
        EDIT: 'SysAvatarDefaultEdit',
        TRANSLATE: 'SysAvatarDefaultTranslate'
    },
    COLOR: {
        INDEX: 'SysAvatarColorList',
        ADD: 'SysAvatarColorAdd',
        EDIT: 'SysAvatarColorEdit'
    },
    LAYER: {
        INDEX: 'SysAvatarLayerList',
        ADD: 'SysAvatarLayerAdd',
        EDIT: 'SysAvatarLayerEdit'
    },
    ITEM: {
        INDEX: 'SysAvatarItemList',
        ADD: 'SysAvatarItemAdd',
        EDIT: 'SysAvatarItemEdit',
        IMAGE: {
            INDEX: 'SysAvatarItemImageList',
            ADD: 'SysAvatarItemImageAdd',
            EDIT: 'SysAvatarItemImageEdit'
        }
    },
    BACKGROUND: {
        INDEX: 'SysAvatarBackgroundList',
        ADD: 'SysAvatarBackgroundAdd',
        EDIT: 'SysAvatarBackgroundEdit'
    }
};

export default [
    {
        path: '/system/avatar/',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: 'gender',
                name: ROUTE_NAME_AVATAR.GENDER,
                component: SysAvatarGender,
                meta: { requiresAuth: true }
            },
            {
                path: 'import',
                name: ROUTE_NAME_AVATAR.IMPORT,
                component: SysAvatarImport,
                meta: { requiresAuth: true }
            },
            {
                path: 'category',
                component: EmptyRouterView,
                meta: { requiresAuth: true },
                children: [
                    {
                        path: '',
                        name: ROUTE_NAME_AVATAR.CATEGORY.INDEX,
                        component: SysAvatarCategoryList,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: 'add',
                        name: ROUTE_NAME_AVATAR.CATEGORY.ADD,
                        component: SysAvatarCategoryAdd,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':categoryId/edit',
                        name: ROUTE_NAME_AVATAR.CATEGORY.EDIT,
                        component: SysAvatarCategoryEdit,
                        meta: { requiresAuth: true }
                    }
                ]
            },
            {
                path: 'bundle',
                component: EmptyRouterView,
                meta: { requiresAuth: true },
                children: [
                    {
                        path: '',
                        name: ROUTE_NAME_AVATAR.BUNDLE.INDEX,
                        component: SysAvatarBundleList,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: 'add',
                        name: ROUTE_NAME_AVATAR.BUNDLE.ADD,
                        component: SysAvatarBundleAdd,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':bundleId/edit',
                        name: ROUTE_NAME_AVATAR.BUNDLE.EDIT,
                        component: SysAvatarBundleEdit,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':bundleId/item',
                        name: ROUTE_NAME_AVATAR.BUNDLE.ITEM,
                        component: SysAvatarBundleItem,
                        meta: { requiresAuth: true }
                    }
                ]
            },
            {
                path: 'default',
                component: EmptyRouterView,
                meta: { requiresAuth: true },
                children: [
                    {
                        path: '',
                        name: ROUTE_NAME_AVATAR.DEFAULT.INDEX,
                        component: SysAvatarDefaultList,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: 'add',
                        name: ROUTE_NAME_AVATAR.DEFAULT.ADD,
                        component: SysAvatarDefaultAdd,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':avatarId/edit',
                        name: ROUTE_NAME_AVATAR.DEFAULT.EDIT,
                        component: SysAvatarDefaultEdit,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':avatarId/translate',
                        name: ROUTE_NAME_AVATAR.DEFAULT.TRANSLATE,
                        component: SysAvatarDefaultTranslate,
                        meta: { requiresAuth: true }
                    }
                ]
            },
            {
                path: 'color',
                component: EmptyRouterView,
                meta: { requiresAuth: true },
                children: [
                    {
                        path: '',
                        name: ROUTE_NAME_AVATAR.COLOR.INDEX,
                        component: SysAvatarColorList,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: 'add',
                        name: ROUTE_NAME_AVATAR.COLOR.ADD,
                        component: SysAvatarColorAdd,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':colorId/edit',
                        name: ROUTE_NAME_AVATAR.COLOR.EDIT,
                        component: SysAvatarColorEdit,
                        meta: { requiresAuth: true }
                    }
                ]
            },
            {
                path: 'layer',
                component: EmptyRouterView,
                meta: { requiresAuth: true },
                children: [
                    {
                        path: '',
                        name: ROUTE_NAME_AVATAR.LAYER.INDEX,
                        component: SysAvatarLayerList,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: 'add',
                        name: ROUTE_NAME_AVATAR.LAYER.ADD,
                        component: SysAvatarLayerAdd,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':layerId/edit',
                        name: ROUTE_NAME_AVATAR.LAYER.EDIT,
                        component: SysAvatarLayerEdit,
                        meta: { requiresAuth: true }
                    }
                ]
            },
            {
                path: 'item',
                component: EmptyRouterView,
                meta: { requiresAuth: true },
                children: [
                    {
                        path: '',
                        name: ROUTE_NAME_AVATAR.ITEM.INDEX,
                        component: SysAvatarItemList,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: 'add',
                        name: ROUTE_NAME_AVATAR.ITEM.ADD,
                        component: SysAvatarItemAdd,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':itemId/edit',
                        name: ROUTE_NAME_AVATAR.ITEM.EDIT,
                        component: SysAvatarItemEdit,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':itemId/image',
                        component: EmptyRouterView,
                        meta: { requiresAuth: true },
                        children: [
                            {
                                path: '',
                                name: ROUTE_NAME_AVATAR.ITEM.IMAGE.INDEX,
                                component: SysAvatarItemImageList,
                                meta: { requiresAuth: true }
                            },
                            {
                                path: 'add',
                                name: ROUTE_NAME_AVATAR.ITEM.IMAGE.ADD,
                                component: SysAvatarItemImageAdd,
                                meta: { requiresAuth: true }
                            },
                            {
                                path: ':imageId/edit',
                                name: ROUTE_NAME_AVATAR.ITEM.IMAGE.EDIT,
                                component: SysAvatarItemImageEdit,
                                meta: { requiresAuth: true }
                            }
                        ]
                    }
                ]
            },
            {
                path: 'background',
                component: EmptyRouterView,
                meta: { requiresAuth: true },
                children: [
                    {
                        path: '',
                        name: ROUTE_NAME_AVATAR.BACKGROUND.INDEX,
                        component: SysAvatarBackgroundList,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: 'add',
                        name: ROUTE_NAME_AVATAR.BACKGROUND.ADD,
                        component: SysAvatarBackgroundAdd,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id/edit',
                        name: ROUTE_NAME_AVATAR.BACKGROUND.EDIT,
                        component: SysAvatarBackgroundEdit,
                        meta: { requiresAuth: true }
                    }
                ]
            }
        ]
    }
];
